require('./src/jquery.daterangepicker.js');
